import { GetInitialVisitSingleAccessoryQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialVisitSingleAccessory/getInitialVisitSingleAccessoryQuery.type';
import { getInitialVisitSingleAccessoryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialVisitSingleAccessory/getInitialVisitSingleAccessoryQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getInitialVisitSingleAccessoryQueryOptions = (
  params: GetInitialVisitSingleAccessoryQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['getInitialVisitSingleAccessoryQueryOptions', params],
    queryFn: () => getInitialVisitSingleAccessoryFunction(params),
    enabled: !!params.part_id,
  });
};
